<div dir="{{rtlEnabled ? 'rtl' : 'ltr'}}" class="main-container content-component" [class.test]="baseUrl && (baseUrl.includes('test') || baseUrl.includes('qa'))">
  <div class="content-container">
    <div class="content-area">
      <header-component></header-component>
      <div class="contents">
        <alert-component></alert-component>
        <router-outlet></router-outlet>
      </div>
    </div>
    <nav class="sidenav" [ngClass]="{'collapsed': !expanded && !pin}">
      <section class="sidenav-content" *ngIf="expanded || pin">
        <div class="collapsed-btn" (click)="navCollapse()">
          <clr-icon shape="arrow" dir="left" size="40" style="padding-left: 16px;padding-bottom: 16px"></clr-icon>
        </div>

        <a [routerLink]="['/buyer/home/' + id]" class="logo-wrapper" (click)="onRouterLinkClick()">
          <img *ngIf="!(sidebarFirstLogo || sidebarSecondLogo)" src="assets/images/Aucxis_w.png" class="aucxis-logo" />
          <img *ngIf="!(sidebarFirstLogo || sidebarSecondLogo)" src="assets/images/efice.png" class="efice-logo" style="display: none;" />
          <img *ngIf="sidebarFirstLogo" [src]="sidebarFirstLogo"/>
          <img *ngIf="sidebarSecondLogo" [src]="sidebarSecondLogo" />
        </a>

        <div class="au-sidebar-menu-item nav-item" *ngIf="tokenService.permissionMet('BuyerPermissions.4', id)">
          <a routerLinkActive="active" [routerLink]="['/buyer/users/' + id]" class="nav-link au-sidebar-menu-item-link" (click)="onRouterLinkClick()">
            <i class="au-sidebar-menu-item-icon dx-icon dx-icon-user"></i>
            <p class="au-sidebar-menu-item-text">{{ 'SHARED.USERS' | translate }}</p>
          </a>
        </div>

        <div class="au-sidebar-menu-item nav-item">
          <a routerLinkActive="active" [routerLink]="['/buyer/supplyforecast/' + id]" class="nav-link au-sidebar-menu-item-link public-supply-forecast-urk" (click)="onRouterLinkClick()">
            <i class="au-sidebar-menu-item-icon dx-icon dx-icon-event"></i>
            <p class="au-sidebar-menu-item-text">{{ 'CONTENT.SUPPLY_FORECAST' | translate }}</p>
          </a>
        </div>

        <div class="au-sidebar-menu-item nav-item" *ngIf="tokenService.permissionMet('BuyerPermissions.1', id) || tokenService.permissionMet('BuyerPermissions.2', id) || tokenService.permissionMet('BuyerPermissions.3', id) || tokenService.permissionMet('BuyerPermissions.4', id) || tokenService.permissionMet('BuyerPermissions.5', id)">
          <a routerLinkActive="active" [routerLink]="['/buyer/supplymonitor/' + id]"
             class="nav-link au-sidebar-menu-item-link" (click)="onRouterLinkClick()">
            <i class="au-sidebar-menu-item-icon dx-icon dx-icon-chevrondoubleright"></i>
            <p class="au-sidebar-menu-item-text">{{ 'SUPPLY_MONITOR.TITLE' | translate }}</p>
          </a>
        </div>

        <div class="au-sidebar-menu-item nav-item" *ngIf="tokenService.permissionMet('BuyerPermissions.1', id) || tokenService.permissionMet('BuyerPermissions.2', id) || tokenService.permissionMet('BuyerPermissions.3', id) || tokenService.permissionMet('BuyerPermissions.4', id) || tokenService.permissionMet('BuyerPermissions.5', id)">
          <a routerLinkActive="active" [routerLink]="['/buyer/supplymatrix/' + id]"
             class="nav-link au-sidebar-menu-item-link" (click)="onRouterLinkClick()">
            <i class="au-sidebar-menu-item-icon dx-icon dx-icon-chevrondoubleright"></i>
            <p class="au-sidebar-menu-item-text">{{ 'SUPPLY_MATRIX.TITLE' | translate }}</p>
          </a>
        </div>

        <div class="au-sidebar-menu-item nav-item" *ngIf="tokenService.permissionMet('BuyerPermissions.2', id)">
          <a routerLinkActive="active" [routerLink]="['/buyer/transactionmonitor/' + id]"
             class="nav-link au-sidebar-menu-item-link" (click)="onRouterLinkClick()">
            <i class="au-sidebar-menu-item-icon dx-icon dx-icon-chevrondoubleright"></i>
            <p class="au-sidebar-menu-item-text">{{ 'TRANSACTION_MONITOR.TITLE' | translate }}</p>
          </a>
        </div>

        <div class="au-sidebar-menu-item nav-item" *ngIf="tokenService.permissionMet('BuyerPermissions.5', id)">
          <a routerLinkActive="active" [routerLink]="['/buyer/shoppinglists/' + id]" class="nav-link au-sidebar-menu-item-link" (click)="onRouterLinkClick()">
            <i class="au-sidebar-menu-item-icon dx-icon dx-icon-cart"></i>
            <p class="au-sidebar-menu-item-text">{{ 'SHOPPING_LIST.TITLE' | translate }}</p>
          </a>
        </div>

        <div class="au-sidebar-menu-item nav-item" *ngIf="tokenService.permissionMet('BuyerPermissions.1', id) || tokenService.permissionMet('BuyerPermissions.2', id) || tokenService.permissionMet('BuyerPermissions.4', id)|| tokenService.permissionMet('BuyerPermissions.6', id)">
          <a routerLinkActive="active" [routerLink]="['/buyer/clocks/' + id]"
             class="nav-link au-sidebar-menu-item-link" (click)="onRouterLinkClick('buyer-clocks')">
            <i class="au-sidebar-menu-item-icon dx-icon dx-icon-money"></i>
            <p class="au-sidebar-menu-item-text">{{ 'AUCTION.TITLE' | translate }}</p>
          </a>
        </div>

        <div class="au-sidebar-menu-item nav-item" *ngIf="tokenService.permissionMet('BuyerPermissions.3', id)">
          <a routerLinkActive="active" [routerLink]="['/buyer/reports/' + id]" class="nav-link au-sidebar-menu-item-link" (click)="onRouterLinkClick()">
            <i class="au-sidebar-menu-item-icon dx-icon dx-icon-bulletlist"></i>
            <p class="au-sidebar-menu-item-text">{{ 'REPORTING.TITLE' | translate }}</p>
          </a>
        </div>

        <ng-container *ngFor="let item of menuItems">
          <collapsable-section *ngIf="item.menuType === 3" [caption]="getTranslation(item.menuItemName)" sectionId="item.menuItemName" (clicked)="onRouterLinkClick('item.menuItemName')">
            <ul class="nav-list">
              <ng-container *ngFor="let subItem of subMenuItems">
                <ng-container *ngIf="item.externalAppId === subItem.submenuId">
                  <li class="au-sidebar-menu-item">
                    <a *ngIf="!subItem.openInNewTab"
                       [routerLink]="['/buyer/' + id + '/menu-item/' + subItem.externalAppId]"
                       routerLinkActive="active"
                       class="nav-link au-sidebar-menu-item-link">
                      <i class="au-sidebar-menu-item-icon dx-icon dx-icon-more"></i>
                      <p class="au-sidebar-menu-item-text">{{ getTranslation(subItem.menuItemName) }}</p>
                    </a>

                    <a *ngIf="subItem.openInNewTab"
                       [href]="subItem.applicationUrl"
                       [target]="'_blank'"
                       routerLinkActive="active"
                       class="nav-link au-sidebar-menu-item-link">
                      <i class="au-sidebar-menu-item-icon dx-icon dx-icon-more"></i>
                      <p class="au-sidebar-menu-item-text">{{ getTranslation(subItem.menuItemName) }}</p>
                    </a>
                  </li>
                </ng-container>
              </ng-container>
            </ul>
          </collapsable-section>

          <ng-container *ngIf="item.menuType === 1">
            <div class="au-sidebar-menu-item">
              <a *ngIf="!item.openInNewTab"
                 [routerLink]="['/buyer/' + id + '/menu-item/' + item.externalAppId]"
                 routerLinkActive="active"
                 class="nav-link au-sidebar-menu-item-link">
                <i class="au-sidebar-menu-item-icon dx-icon dx-icon-more"></i>
                <p class="au-sidebar-menu-item-text">{{ getTranslation(item.menuItemName) }}</p>
              </a>

              <a *ngIf="item.openInNewTab"
                 [href]="item.applicationUrl"
                 [target]="'_blank'"
                 routerLinkActive="active"
                 class="nav-link au-sidebar-menu-item-link">
                <i class="au-sidebar-menu-item-icon dx-icon dx-icon-more"></i>
                <p class="au-sidebar-menu-item-text">{{ getTranslation(item.menuItemName) }}</p>
              </a>
            </div>
          </ng-container>

          <ng-container *ngIf="item.menuType === 2">
            <div class="au-sidebar-menu-item">
              <a [routerLink]="['/buyer/' + id + '/menu-item/' + item.externalAppId]"
                 routerLinkActive="active"
                 class="nav-link au-sidebar-menu-item-link">
                <i class="au-sidebar-menu-item-icon dx-icon dx-icon-more"></i>
                <p class="au-sidebar-menu-item-text">{{ getTranslation(item.menuItemName) }}</p>
              </a>
            </div>
          </ng-container>
        </ng-container>

      </section>

      <div class="au-sidebar-bottom-brand-area">
        <a *ngIf="expanded || pin" [href]="kosmosURL" target="_blank" class="bottom-logo-wrapper">
          <img src="assets/images/kosmos.png" />
        </a>
        <version-component></version-component>
      </div>

      <section class="sidenav-content" *ngIf="!expanded && !pin">
        <a [routerLink]="['/core/home']" class="small-logo-wrapper">
          <!--<img src="assets/images/europool_logo_small.png" />-->
        </a>
        <div class="expand-btn" (click)="navExpand()">
          <clr-icon shape="arrow right" size="32"></clr-icon>
        </div>
        <a [href]="kosmosURL" target="_blank" class="bottom-logo-wrapper">
          <img src="assets/images/kosmos_vert.png" />
        </a>
      </section>
    </nav>
  </div>
</div>
<spinner-component></spinner-component>
